import { Component, EventEmitter, Output } from '@angular/core';
import { SupportUsersTab } from '../../models/support-users-tab';

@Component({
    selector: 'app-tab-container',
    templateUrl: './tab-container.component.html',
    styleUrls: ['./tab-container.component.scss'],
    standalone: false
})
export class TabContainerComponent {
  @Output() tabChange = new EventEmitter<SupportUsersTab>();
  activeTab: SupportUsersTab = 'client';

  changeTab(tab: SupportUsersTab) {
    this.tabChange.emit(tab);
    this.activeTab = tab;
  }
}
